<div class="graph-direction">
    <div *ngIf="dataToDisplay" class="timelineData">
        <p>{{graphId}}</p>
        <div class="timeline-posture">
            <div class="posture-item">
                <div class="posture-color supine-color"></div>
                <p class="posture-label">{{ 'Supine' | translate }}</p>
            </div>

            <div class="posture-item">
                <div class="posture-color right-color"></div>
                <p class="posture-label">{{ 'Right' | translate }}</p>
            </div>

            <div class="posture-item">
                <div class="posture-color prone-color"></div>
                <p class="posture-label">{{ 'Prone' | translate }}</p>
            </div>

            <div class="posture-item">
                <div class="posture-color left-color"></div>
                <p class="posture-label">{{ 'Left' | translate }}</p>
            </div>

            <div class="posture-item">
                <div class="posture-color nopatient-color"></div>
                <p class="posture-label">{{ 'NPP' | translate }}</p>
            </div>

            <div class="posture-item">
                <div class="posture-color nodata-color"></div>
                <p class="posture-label">{{ 'no data' | translate }}</p>
            </div>
        </div>
    </div>
    <div class="timeline" [id]="timelineId" (resized)="onResized($event)"></div>
</div>